import { EventLargeCard } from "@components/cards/EventLargeCard"
import { AwardSeasonLandingPage } from "@features/awards/components/AwardSeasonLandingPage"
import { AwardStatus } from "@features/awards/components/AwardStatus"
import { ContentBlocks, InnerBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("single-award", (props) => {
  return <AwardSeasonLandingPage award={props.award!} />
})
